"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Telegraph Public API
 * Public API offering access to Telegraph data
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: bookingsupport@telegraph.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportLicenseX1ToJSON = exports.ExportLicenseX1FromJSONTyped = exports.ExportLicenseX1FromJSON = exports.instanceOfExportLicenseX1 = void 0;
/**
 * Check if a given object implements the ExportLicenseX1 interface.
 */
function instanceOfExportLicenseX1(value) {
    return true;
}
exports.instanceOfExportLicenseX1 = instanceOfExportLicenseX1;
function ExportLicenseX1FromJSON(json) {
    return ExportLicenseX1FromJSONTyped(json, false);
}
exports.ExportLicenseX1FromJSON = ExportLicenseX1FromJSON;
function ExportLicenseX1FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code_for_licensing_certification_registration_or_accreditation_agency_01': json['code_for_licensing_certification_registration_or_accreditation_agency_01'] == null ? undefined : json['code_for_licensing_certification_registration_or_accreditation_agency_01'],
        'export_license_number_02': json['export_license_number_02'] == null ? undefined : json['export_license_number_02'],
        'export_license_status_code_03': json['export_license_status_code_03'] == null ? undefined : json['export_license_status_code_03'],
        'date_04': json['date_04'] == null ? undefined : (new Date(json['date_04'])),
        'export_license_symbol_code_05': json['export_license_symbol_code_05'] == null ? undefined : json['export_license_symbol_code_05'],
        'export_license_control_code_06': json['export_license_control_code_06'] == null ? undefined : json['export_license_control_code_06'],
        'country_code_07': json['country_code_07'] == null ? undefined : json['country_code_07'],
        'schedule_b_code_08': json['schedule_b_code_08'] == null ? undefined : json['schedule_b_code_08'],
        'international_domestic_code_09': json['international_domestic_code_09'] == null ? undefined : json['international_domestic_code_09'],
        'lading_quantity_10': json['lading_quantity_10'] == null ? undefined : json['lading_quantity_10'],
        'lading_value_11': json['lading_value_11'] == null ? undefined : json['lading_value_11'],
        'export_filing_key_code_12': json['export_filing_key_code_12'] == null ? undefined : json['export_filing_key_code_12'],
        'unit_or_basis_for_measurement_code_13': json['unit_or_basis_for_measurement_code_13'] == null ? undefined : json['unit_or_basis_for_measurement_code_13'],
        'unit_price_14': json['unit_price_14'] == null ? undefined : json['unit_price_14'],
        'us_government_license_type_15': json['us_government_license_type_15'] == null ? undefined : json['us_government_license_type_15'],
        'identification_code_16': json['identification_code_16'] == null ? undefined : json['identification_code_16'],
        'location_identifier_17': json['location_identifier_17'] == null ? undefined : json['location_identifier_17'],
    };
}
exports.ExportLicenseX1FromJSONTyped = ExportLicenseX1FromJSONTyped;
function ExportLicenseX1ToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'code_for_licensing_certification_registration_or_accreditation_agency_01': value['code_for_licensing_certification_registration_or_accreditation_agency_01'],
        'export_license_number_02': value['export_license_number_02'],
        'export_license_status_code_03': value['export_license_status_code_03'],
        'date_04': value['date_04'] == null ? undefined : ((value['date_04']).toISOString()),
        'export_license_symbol_code_05': value['export_license_symbol_code_05'],
        'export_license_control_code_06': value['export_license_control_code_06'],
        'country_code_07': value['country_code_07'],
        'schedule_b_code_08': value['schedule_b_code_08'],
        'international_domestic_code_09': value['international_domestic_code_09'],
        'lading_quantity_10': value['lading_quantity_10'],
        'lading_value_11': value['lading_value_11'],
        'export_filing_key_code_12': value['export_filing_key_code_12'],
        'unit_or_basis_for_measurement_code_13': value['unit_or_basis_for_measurement_code_13'],
        'unit_price_14': value['unit_price_14'],
        'us_government_license_type_15': value['us_government_license_type_15'],
        'identification_code_16': value['identification_code_16'],
        'location_identifier_17': value['location_identifier_17'],
    };
}
exports.ExportLicenseX1ToJSON = ExportLicenseX1ToJSON;
